import Grid from "@material-ui/core/Grid";
import Bignumber from "./Bignumber";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import MaskAndValid from "utils/maskAndValid";

export default function BignumbersRetireNaLoja({ data, onClickLabel }) {
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de pedidos"
          value={data.rlQtdPedidos}
          icon={ListAltIcon}
          onClickLabel={() => onClickLabel("pedidos")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de vendas incrementais"
          value={data.rlQtdVendasIncrementais}
          onClickLabel={() => onClickLabel("vendasIncrementais")}
          icon="fas fa-pallet"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Valor das vendas incrementais"
          value={
            data.rlValorVendasIncrementais !== null
              ? "R$" + MaskAndValid.maskPrice(data.rlValorVendasIncrementais)
              : null
          }
          icon={AttachMoneyIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de peças incrementais"
          value={data.rlQtdPecasVendasIncrementais}
          icon="ni ni-settings-gear-65"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Preço médio"
          value={
            data.rlPrecoMedioVendasIncrementais !== null
              ? "R$" +
                MaskAndValid.maskPrice(data.rlPrecoMedioVendasIncrementais)
              : null
          }
          icon={LocalOfferIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Ticket médio"
          value={
            data.rlTicketMedioVendasIncrementais !== null
              ? "R$" +
                MaskAndValid.maskPrice(data.rlTicketMedioVendasIncrementais)
              : null
          }
          icon={ConfirmationNumberIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Peças por atendimento"
          value={MaskAndValid.maskDecimal(
            data.rlPecasPorAtendimentoVendasIncrementais,
            2
          )}
          icon="fas fa-boxes"
        />
      </Grid>
    </Grid>
  );
}
